(function () {
  if (window.__herbionRetailerTrackingBound) return;
  window.__herbionRetailerTrackingBound = true;

  var campaignPage = window.location.pathname.replace(/\/$/, '') === '/pages/walmart';
  var params = new URLSearchParams(window.location.search);
  var attribution = {
    campaign_name: params.get('utm_campaign') || '',
    campaign_source: params.get('utm_source') || '',
    campaign_medium: params.get('utm_medium') || '',
    campaign_content: params.get('utm_content') || ''
  };

  if (campaignPage) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'herbion_walmart_landing_view', page_path: window.location.pathname }, attribution));
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-herbion-retailer-link]');
    if (!link) return;

    var payload = {
      retailer: link.dataset.retailer || 'Amazon Canada',
      retailer_position: Number(link.dataset.retailerPosition || 1),
      product_id: link.dataset.productId || '',
      product_name: link.dataset.productTitle || '',
      product_handle: link.dataset.productHandle || '',
      destination_url: link.href,
      page_path: window.location.pathname,
      campaign_name: attribution.campaign_name,
      campaign_source: attribution.campaign_source,
      campaign_medium: attribution.campaign_medium,
      campaign_content: attribution.campaign_content,
      campaign_id: campaignPage ? 'herbion_walmart_influencer' : ''
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'retailer_click' }, payload));

    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', 'RetailerClick', {
        retailer: payload.retailer,
        retailer_position: payload.retailer_position,
        product_name: payload.product_name,
        product_handle: payload.product_handle,
        destination_url: payload.destination_url,
        campaign_name: payload.campaign_name,
        campaign_source: payload.campaign_source,
        campaign_content: payload.campaign_content
      });
    }

    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    ) {
      try {
        var published = Shopify.analytics.publish('herbion:retailer_click', payload);
        if (published && typeof published.catch === 'function') {
          published.catch(function () {});
        }
      } catch (e) {}
    }
  });
})();